export const formScenes = {
  email: "email",
  phone: "phone",
  password: "password",
  confirm: "confirm"
};
